import * as d3 from 'd3-selection'
import { path } from 'd3-path'

const defaultRadius = 4

const theta = 34 * (Math.PI / 180)

function tipDimensions (tipHeight, width, offset = 0) {
  var tipHeight = tipHeight + offset
    , tipWidth = tipHeight / Math.tan(theta)
    , radius = defaultRadius

  // The flappers would extend the size
  if (tipWidth * 2 > width) {
    tipWidth = width / 2 // Both flappers should touch tips
    tipHeight = Math.tan(theta) * (width / 2)
    radius = tipWidth / 2 // Decrease the radius
  }

  return {
    width: tipWidth,
    height: tipHeight,
    radius: radius,
    offset: offset
  }
}

export default function (selection, y, height) {
  selection.each(function (d) {
    var context = path()
      , width = d.x2 - d.x1
      , rightTip = tipDimensions(d.tipHeight, width, d.rightTipOffset)
      , leftTip = tipDimensions(d.tipHeight, width, d.leftTipOffset)
      , radius = Math.min(rightTip.radius, leftTip.radius)

    // Make sure the radius isn't over 50% of the width
    radius = Math.min(radius, width * .50)

    var _radius = {
      tr: radius,
      tl: radius,
      br: radius,
      bl: radius
    }

    // See if there's a radius override for the tops. Cannot override bottom b/c the designs don't require it.
    if (d.topRightRadius !== undefined) {
      _radius.tr = d.topRightRadius
    }

    if (d.topLeftRadius !== undefined) {
      _radius.tl = d.topLeftRadius
    }

    // Let's draw
    context.moveTo(d.x1 + _radius.tl, y) // Start position in top left corner
    context.lineTo(d.x2 - _radius.tr, y) // Draw the horizontal top line
    context.quadraticCurveTo(d.x2, y, d.x2, y + _radius.tr) // Arc around top right corner

    if (rightTip.height || leftTip.height) {
      // Showing pointy tips in corners
      context.lineTo(d.x2, y + height + rightTip.offset) // Straight down
      context.lineTo(Math.max(0, d.x2 - rightTip.width), y + height - rightTip.height + rightTip.offset) // Cut the tip back up to the left

      context.lineTo(d.x1 + leftTip.width, y + height - leftTip.height + leftTip.offset) // Send it back to the left of the component
      context.lineTo(d.x1, y +  height + leftTip.offset) // Back down to the bottom left tip
    } else {
      // Rounded bottoms
      context.lineTo(d.x2, y + height - _radius.br) // Straight down
      context.quadraticCurveTo(d.x2, y + height, d.x2 - _radius.br, y + height)
      context.lineTo(d.x1 + _radius.bl, y + height) // Horizontal bottom line
      context.quadraticCurveTo(d.x1, y + height, d.x1, y + height - _radius.bl)
    }

    context.lineTo(d.x1, y + _radius.tl) // Bottom left corner straight up
    context.quadraticCurveTo(d.x1, y, d.x1 + _radius.tl, y) // Curve back to starting point

    d3.select(this)
      .attr('d', context.toString())
  })
}
